import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, spotMove } from "../site/Motion";
import { fileUrl } from "../../lib/api";

const span = (i, n) => {
  if (i === 0) return "md:col-span-2 lg:row-span-2";
  const wides = (4 - ((n + 3) % 4)) % 4;
  if (i >= 5 && i < 5 + wides) return "md:col-span-2";
  return "";
};

const CategoryCard = ({ c, i, n }) => (
  <Reveal delay={(i % 4) * 0.06} className={`h-full ${span(i, n)}`}>
    <Link
      to={`/products/${c.slug}`}
      onMouseMove={spotMove}
      data-testid={`category-card-${c.slug}`}
      className="spot clip-corner group relative flex h-full min-h-[260px] flex-col justify-between overflow-hidden bg-[#0d121b] p-6"
    >
      <img
        src={fileUrl(c.image)}
        alt={c.name}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover opacity-70 transition-[transform,opacity] duration-[1.2s] ease-out group-hover:scale-[1.06] group-hover:opacity-90"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#07090e] via-[#07090e]/50 to-transparent" />
      <div className="relative z-10 flex items-start justify-between">
        <span className="font-mono-x text-xs text-slate-300">{String(i + 1).padStart(2, "0")}</span>
        <span className="flex h-10 w-10 items-center justify-center border border-slate-500/50 text-white transition-[background-color,border-color,transform] duration-300 group-hover:rotate-45 group-hover:border-[#0a6cff] group-hover:bg-[#0a6cff]">
          <ArrowUpRight className="h-4 w-4" />
        </span>
      </div>
      <div className="relative z-10">
        <p className="eyebrow !text-[10px] text-sky-400">{c.tagline}</p>
        <h3 className={`font-display mt-2 font-extrabold uppercase leading-[0.9] text-white ${i === 0 ? "text-5xl md:text-6xl" : "text-3xl"}`}>{c.name}</h3>
        {i === 0 && <p className="mt-3 max-w-sm text-sm text-slate-300">{c.description}</p>}
        <p className="font-mono-x mt-3 text-[11px] uppercase tracking-widest text-slate-400">{c.product_count ?? 0} parts</p>
      </div>
    </Link>
  </Reveal>
);

export const CategoryBento = ({ categories }) => (
  <div data-testid="product-category-grid" className="grid grid-flow-dense auto-rows-[260px] grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
    {categories.map((c, i) => <CategoryCard key={c.id} c={c} i={i} n={categories.length} />)}
  </div>
);
